/* draco-bogo-badge.js
 * Draws "BOGO 50% OFF" top-left on every eligible product card, flips to
 * "BOGO FREE" when the discount switches, removes itself when the promo ends.
 *
 * THE DATES BELOW MUST MATCH THE SHOPIFY DISCOUNTS or the badge lies:
 *   BOGO 50% OFF  ends  2026-11-23T00:00 EST
 *   BOGO FREE     runs  2026-11-23T00:00 -> 2026-11-28T00:00 EST
 *
 * Eligibility comes from /collections/draco-collection/products.json, the one
 * collection BOTH discounts target, so the badge can never disagree with what
 * the cart charges. Fetched rather than rendered from Liquid because
 * collection.products caps at 50 and the collection holds 72. The feed returns
 * only storefront-published, in-stock products, which is exactly the set a
 * shopper can see a card for: the VIP colourways are publishedAt:null so they
 * never appear, and neither does Mystery, removed from the collection on
 * purpose. Failure is silent by design: no badge beats a wrong badge.
 *
 * Deferred on purpose. Unlike the Draco+ checkbox, nothing here is clickable,
 * so arriving a moment late costs nothing.
 */
(function () {
  var FLIP = Date.parse('2026-11-23T00:00:00-05:00');
  var END  = Date.parse('2026-11-28T00:00:00-05:00');
  if (Date.now() >= END) return;

  var WRAPS = '.fcs-card__image-wrap, .dcg-card__image-wrap';

  var css = '.draco-bogo-badge{position:absolute;top:10px;left:10px;z-index:2;background:#0B0B0B;color:#fff;'
    + "font-family:'Inter',sans-serif;font-size:9px;font-weight:600;letter-spacing:.06em;line-height:1.2;"
    + 'padding:3px 6px;border-radius:2px;pointer-events:none}'
    + '.draco-bogo-badge b{color:inherit;font-weight:600}'
    + '.dcg-card__image-wrap:has(.draco-bogo-badge) .dcg-badge{display:none}'
    + '@media (min-width:750px){.draco-bogo-badge{top:12px;left:12px;font-size:10px;padding:4px 8px}}';
  var st = document.createElement('style');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function label() {
    var n = Date.now();
    if (n >= END) return null;
    return n >= FLIP ? 'FREE' : '50% OFF';
  }

  var eligible = null;

  function paint() {
    if (!eligible) return;
    var txt = label();
    var wraps = document.querySelectorAll(WRAPS);
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var have = w.querySelector('.draco-bogo-badge');
      if (!txt) { if (have) have.parentNode.removeChild(have); continue; }
      var a = w.querySelector('a[href*="/products/"]');
      var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m || !eligible[m[1]]) { if (have) have.parentNode.removeChild(have); continue; }
      if (have) {
        var b = have.querySelector('b');
        if (b && b.textContent !== txt) b.textContent = txt;
        continue;
      }
      var s = document.createElement('span');
      s.className = 'draco-bogo-badge';
      s.appendChild(document.createTextNode('BOGO '));
      var strong = document.createElement('b');
      strong.textContent = txt;
      s.appendChild(strong);
      w.insertBefore(s, w.firstChild);
    }
  }

  fetch('/collections/draco-collection/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      eligible = {};
      (d.products || []).forEach(function (p) {
        if (!p.handle || p.handle.indexOf('mystery') !== -1) return;
        var inStock = (p.variants || []).some(function (v) { return v.available; });
        if (inStock) eligible[p.handle] = true;
      });
      paint();
      // Cards mount late in sliders and re-render on filtering, so keep watching.
      if (window.MutationObserver) {
        var t;
        new MutationObserver(function () {
          clearTimeout(t); t = setTimeout(paint, 120);
        }).observe(document.body, { childList: true, subtree: true });
      }
      setInterval(paint, 30000); // crosses the flip without a reload
    })['catch'](function () { /* no badge is better than a wrong badge */ });
})();